import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-body py-4 d-flex align-items-center flex-wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bold me-5" }, "Dükkan Durumu", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_5 = { class: "fw-bold me-2" }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "btn btn-sm btn-light",
  disabled: "",
  title: "Bu hesapta dükkanı açma/kapama yetkisi bulunmuyor"
}
const _hoisted_8 = {
  key: 1,
  class: "text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.loading && _ctx.statuses.length === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Yükleniyor... "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (s, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "d-flex align-items-center me-8 my-1"
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name(s.integrationType)) + ":", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["badge fs-7 me-3", 
              s.open === true
                ? 'badge-light-success'
                : s.open === false
                ? 'badge-light-danger'
                : 'badge-light-warning'
            ])
          }, _toDisplayString(s.open === true
                ? "AÇIK"
                : s.open === false
                ? "KAPALI"
                : s.status === 'NO_ACCESS'
                ? "Yetkisizsiniz"
                : "Bilinmiyor"), 3),
          (s.open !== null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn btn-sm", s.open ? 'btn-light-danger' : 'btn-light-success']),
                disabled: _ctx.busy,
                onClick: ($event: any) => (_ctx.toggle(s))
              }, _toDisplayString(s.open ? "Kapat" : "Aç"), 11, _hoisted_6))
            : (s.status === 'NO_ACCESS')
              ? (_openBlock(), _createElementBlock("button", _hoisted_7, " Yetkisiz "))
              : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!_ctx.loading && _ctx.statuses.length === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Dükkan aç/kapa destekleyen entegrasyon yok. "))
        : _createCommentVNode("", true)
    ])
  ]))
}